/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("PropertyDictNode", ["StandardNode", "NodeFactory"], function (context, cls) {
  /**
   * @class PropertyDictNode
   * @memberOf classes
   * @extends classes.StandardNode
   */
  class PropertyDictNode extends cls.StandardNode /** @lends classes.PropertyDictNode.prototype */ {
    constructor(parent, tag, id, attributes, app) {
      super(parent, tag, id, attributes, app);
    }

    get _canEmitNodeMutation() {
      if (this._internalCanEmitNodeMutation) {
        return this._internalCanEmitNodeMutation;
      }
      return true;
    }

    set _canEmitNodeMutation(value) {
      this._internalCanEmitNodeMutation = value;
    }
  }
  cls.PropertyDictNode = PropertyDictNode;
  cls.NodeFactory.register("PropertyDict", cls.PropertyDictNode);
});
